import React from 'react';
import PropTypes from 'prop-types';

function IconSearch({ stroke, strokeWidth }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      id="search-1"
      className="customSVG"
      stroke={stroke}
      strokeWidth={strokeWidth}
    >
      <path data-name="layer2" fill="none" d="M39.049 39.049L56 56" />
      <circle data-name="layer1" cx="27" cy="27" r="17" fill="none" />
    </svg>
  );
}

IconSearch.propTypes = {
  stroke: PropTypes.string,
  strokeWidth: PropTypes.string,
};

IconSearch.defaultProps = {
  stroke: 'black',
  strokeWidth: '2',
};

export default IconSearch;
